import * as z from "zod";

export const formSchema = z.object({
  fullName: z.string().min(1, "Name is required"),
  email: z.string().email().min(1, "Email is required"),
  mobile: z.string().min(1, "Mobile is required"),
  address: z.string().min(1, "Address is required"),
  academicLevel: z.string().min(1, "Academic level is required"),
  message: z.string(),
  course: z.string().min(1, "Course is required"),
});

export type FormValues = z.infer<typeof formSchema>;
